import { render, staticRenderFns } from "./StreamMenu.vue?vue&type=template&id=1c8b7e6f&scoped=true&"
import script from "./StreamMenu.vue?vue&type=script&lang=js&"
export * from "./StreamMenu.vue?vue&type=script&lang=js&"
import style0 from "./StreamMenu.vue?vue&type=style&index=0&id=1c8b7e6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b7e6f",
  null
  
)

export default component.exports